import { ScheduledDowngradeConfirmationModal } from "../PlanDetails/ScheduledDowngradeConfirmationModal";
import {
  useUpgradeFlowFormContext,
  useUpgradeFlowShellContext,
} from "../UpgradeFlowContext";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const ScheduledDowngradeConfirmationRoute = () => {
  const { modal } = useUpgradeFlowShellContext();
  const { onSubmitHandler } = useUpgradeFlowFormContext();
  const { plan } = useUpgradePlanContext();

  return (
    <ScheduledDowngradeConfirmationModal
      hideModal={modal.hide}
      onSubmitHandler={onSubmitHandler}
      plan={plan}
    />
  );
};
